import api from '@/shared/api/base-api';
import { Brand, BrandParams, BrandsResponse } from '../model/types';

export const brandApi = {
  getAll: async (params: BrandParams): Promise<BrandsResponse> => {
    const { data } = await api.get('/v2/aggregator-shipper', { params });
    return data;
  },
  getById: async (id?: string, params?: BrandParams): Promise<Brand> => {
    const { data } = await api.get(`/v2/aggregator-shipper/${id}`, { params });
    return data;
  },
};
